import { Component, Input, Output, EventEmitter, AfterViewInit, ViewChild, ElementRef, OnChanges, SimpleChanges, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { FormsModule } from '@angular/forms';

import { TextareaModule } from 'primeng/textarea';

@Component({
  selector: 'app-text-area',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
  standalone: true,
  imports: [FormsModule, TextareaModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextareaComponent),
      multi: true,
    },
  ],
})

export class TextareaComponent implements AfterViewInit, OnChanges {
  @Input() value: string = '';
  @Input() required: boolean = false;
  @Input() rows: number = 3;
  @Input() cols: number = 30;
  @Input() placeholder: string = '';
  @Input() customErrorMessage: string = '';
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() change: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('textarea', { static: false }) textarea: ElementRef | undefined;
  touched: boolean = false;
  errorMessage: string = '';
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']) {
      this.value = changes['value'].currentValue;
      this.setAutoResize();
      this.setInitialSize();
      this.onTouched();
    }
  }
  writeValue(value: string): void {

    if (value !== undefined) {
      this.value = value;
    }
  }


  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }


  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  validate(): void {
    if (this.required && !this.value.trim()) {
      this.errorMessage = this.customErrorMessage || 'This field is required';
    } else {
      this.errorMessage = '';
    }
  }

  get isRequiredAndEmpty(): boolean {
    return this.required && !this.value.trim();
  }

  onFocus(): void {
    this.touched = true;
  }

  onBlur(): void {
    this.touched = true;
    this.validate();
  }

  onValueChange(event: any): void {
    this.value = event.target.value;
    this.valueChange.emit(this.value);
    this.change.emit(this.value);
    this.setAutoResize();
    this.setInitialSize();
    this.validate();
  }

  ngAfterViewInit() {
    this.setInitialSize();
  }

  setInitialSize(): void {
    if (this.textarea && this.textarea.nativeElement) {
      const textareaElement = this.textarea.nativeElement;
      textareaElement.style.height = `${this.rows * 20}px`;
      textareaElement.style.width = `${this.cols * 10}px`;
    }
  }

  setAutoResize(): void {
    if (this.textarea && this.textarea.nativeElement) {
      const textareaElement = this.textarea.nativeElement;
      textareaElement.style.height = 'auto';
      textareaElement.style.height = `${textareaElement.scrollHeight}px`;
    }
  }

  private onChange: (value: string) => void = () => { };
  private onTouched: () => void = () => { };
}